/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Available({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M8.687 10.673h3.482a2.673 2.673 0 1 0 0-5.345H8.686c.249.366.447.77.587 1.2h2.896a1.473 1.473 0 1 1 0 2.945H9.273c-.14.43-.338.833-.586 1.2" /><path fill="currentColor" fillRule="evenodd" d="M4.731 4.427a3.573 3.573 0 1 0 0 7.146 3.573 3.573 0 0 0 0-7.146m0 1.2a2.373 2.373 0 1 0 0 4.746 2.373 2.373 0 0 0 0-4.746" clipRule="evenodd" /></svg>;
}
;